import { AxiosResponse } from 'axios'
import {
    IAuthContext,
    IAuthEmail,
    IAuthLogin,
    IAuthRecoveryCode,
    IAuthResetPassword,
    IMessage,
    IAuthStatusUserSchema,
    IAuthAccess,
    IAuthUserUpdate,
} from '../../interfaces'
import api from '../api/server'

export default class AuthService {
    public static async getVerifyEmail(email: string): Promise<IAuthStatusUserSchema> {
        return (await api.get<IAuthStatusUserSchema>(`/users/verify-email/${email}`)).data
    }

    public static async login(data: IAuthLogin): Promise<IAuthContext> {
        return (await api.post<IAuthContext>('/users/login', data)).data
    }

    public static async postSignUp(data: IAuthAccess): Promise<IMessage> {
        return (await api.post<IMessage>('/users/sign-up', data)).data
    }

    public static async patchUpdate(data: IAuthUserUpdate): Promise<IMessage> {
        return (await api.patch<IMessage>('/users/update-registration', data)).data
    }

    public static async emailConfirmation(data: IAuthEmail): Promise<IMessage> {
        return (await api.post<IMessage>('/users/request-reset-password', data)).data
    }

    public static async sendRecoveryCode(data: IAuthRecoveryCode): Promise<IMessage> {
        return (await api.post<IMessage>('/users/verify-reset-password', data)).data
    }

    public static async sendResetPassword(data: IAuthResetPassword): Promise<IMessage> {
        return (await api.put<IMessage>('/users/reset-password', data)).data
    }

    public static async refreshToken(refreshToken: string): Promise<AxiosResponse> {
        return await api.post<AxiosResponse>('/users/refresh-token', { refreshToken })
    }
}
